import React from 'react'
import moment from 'moment'
import { Link } from 'react-router'
import { Form, FormGroup, FormControl } from 'react-bootstrap'
import {fetchAllBillingHistory, fetchAllCustomerTaskTypes} from '../api'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'

// let mediaServer = root + '/common/latest/images/consumer/flat-task-icons/'
var historyTable = [];
var newTaskOptions = [];
var loading = true;
export default React.createClass({
  getInitialState: function () {
    return {
      typeFilter: 'ALL',
      dateFilter: 'ALL',
      data: [],
      taskTypes: []
    }
  },
  componentDidMount: function () {
    this.refreshPage(true)
  },
  componentWillReceiveProps: function(nextProps){
    // This is better than it was but still calls the routes twice. I don't have the gumption right now to fix it beyond that.
    if (this.props.billingHistory !== nextProps.billingHistory) {
        this.refreshPage(false, nextProps)
    }
  },
  refreshPage: function(initial, props) {
    if(initial) {
        fetchAllBillingHistory(this.state.dateFilter, this.state.typeFilter).then((response) => {
            this.populateTaskOptions()
            this.setState({data: response})
        })
    } else {
        this.setState({data: this.props.billingHistory})
    }
  },
  populateTable: function(data) {
    historyTable = [];
    if(data.length !== 0){
      loading = false;
      data.sort(function(a,b) { return a.date - b.date}).reverse();
      for (let i = 0; i < data.length; i++) {
        let pojo = data[i]

        let taskTypeInfo = getTaskTypeIconParser(pojo.taskType)

        let serviceText = "", costClass = ""
        if (pojo.invoiceType === "DEPOSIT") {
            serviceText = pojo.paymentDirection === "paymentDirection.outgoing" ? '<img src="/common/latest/images/consumer/icon_refund.png"> <b class="brand-primary-color" style="margin-left: 10px">REFUND</b>' : '<img src="/common/latest/images/consumer/icon_deposit.png" style="height: 30px"> <b style="margin-left: 10px">DEPOSIT</b>'
	        costClass = pojo.paymentDirection === "paymentDirection.outgoing" ? ' brand-primary-color italic' : ""
        } else {
            serviceText = pojo.serviceDate === 0 ? "" : `<b class="visible-xs-inline">Service Date:&nbsp;</b>${moment(pojo.serviceDate).format('M/D/Y')}`
        }

        let payDate = pojo.date === 0 ? "---" : moment(pojo.date).format('M/D/Y')

        let propertyAddress = pojo.propertyAddress === undefined ? "---" : pojo.propertyAddress
        propertyAddress = propertyAddress.replace(",", "<br>")

        let payment = (pojo.amount).toFixed(2);

        payment = `$${payment}`

        let paymentMethod = "**** **** **** " + pojo.paymentMethod

          // Force this link to the correct path so that our weird app sniffer knows what to do but we keep the same sub-path for JKMount
        let invoiceLink = "/invoice/" + pojo.invoiceId

        historyTable.push(
        <tr key={i} className="text-center">
          <td><Link to={invoiceLink} target="_blank">{payDate}</Link></td>
          <td className="task-type center small no-margin">
            <div className={`${taskTypeInfo.iconsrc}-icon`} /><div className={`task-text ${taskTypeInfo.iconsrc}-color`}>{taskTypeInfo.prettify}</div>
          </td>
          <td className="text-left" dangerouslySetInnerHTML={{__html:propertyAddress}} />
          <td dangerouslySetInnerHTML={{__html:serviceText}} style={{display: 'flex', alignItems: 'center'}} />
          <td className={'text-right bold' + costClass}>{payment}</td>
          <td><span className="visible-xs-inline">Card number:&nbsp;</span>{paymentMethod}</td>
        </tr>)
      }
    } else {
      historyTable = [<tr key="no-history">
        <td colSpan={6} className="text-center bold">No Billing History To Display Yet</td>
      </tr>]
      loading = false;
    }
  },
  populateTaskOptions: function() {
    if(this.props.address){
        fetchAllCustomerTaskTypes().then((data) => {
            for(let i = 0; i < data.length; i++){
              newTaskOptions.push(<option key={i} value={data[i].taskType}>{data[i].name}</option>)
            }
            this.setState({taskTypes: data})
        })
    }
  },
  onTypeFilterChange: function() {
    fetchAllBillingHistory(document.getElementById('dates').value, document.getElementById('tasks').value).then((response) => {
      this.populateTable(response);
      this.setState({data: response, dateFilter: document.getElementById('dates').value, typeFilter: document.getElementById('tasks').value})
    })
  },
  render: function () {
    let loadingImage
    if (loading) {
      loadingImage = <div style={{textAlign: 'center'}}><img src='/common/latest/images/play/spinner.gif' alt='loading' className='pull-down-xs-2' style={{marginBottom: '5px'}} /></div>
    }

    this.populateTable(this.state.data);

    return (
      <div>
        <div className='row pull-down-xs-2'>
          <div className='col-xs-4'>
            <h4 >Billing History</h4>
          </div>
          <div className='col-xs-4'>
            <Form className="row" horizontal={true}>
              <FormGroup style={{margin: 'auto', marginBottom: 0}}>
                <div className='col-sm-3'>
                  <label className='control-label'>Dates:</label>
                </div>
                <div className='col-sm-9'>
                  <i className="fa fa-caret-down billing-history-drop-down-arrow" aria-hidden="true" />
                  <FormControl id='dates' componentClass='select' placeholder='select' onChange={() => this.onTypeFilterChange()} className='form-drop-down'>
                    <option value='ALL'>All Dates</option>
                    <option value='TODAY'>Today</option>
                    <option value='THIS_WEEK'>This Week</option>
                    <option value='LAST_7_DAYS'>Last 7 Days</option>
                    <option value='LAST_30_DAYS'>Last 30 Days</option>
                  </FormControl>
                </div>
              </FormGroup>
            </Form>
          </div>
          <div className="col-xs-4">
            <Form className="row" horizontal={true}>
              <FormGroup style={{margin: 'auto', marginBottom: 0}}>
                <div className="col-sm-3">
                  <label className="control-label" htmlFor="tasks">Show:</label>
                </div>
                <div className="col-sm-9">
                  <i className="fa fa-caret-down billing-history-drop-down-arrow" aria-hidden="true" />
                  <FormControl id='tasks' componentClass='select' placeholder='select' onChange={() => this.onTypeFilterChange()} className='form-drop-down'>
                    <option value='ALL'>All Tasks</option>
                      {newTaskOptions}
                  </FormControl>
                </div>
              </FormGroup>
            </Form>
          </div>
          {loadingImage}
        </div>
        <div className="row pull-down-xs-2">
          <div className="col-xs-12">
            <table style={{borderTop: 0}} className='table table-striped table-bordered table-responsive table-middle'>
              <thead>
              <tr className='olive-green-color' >
                <th>Date</th>
                <th>Task</th>
                <th>Property Address</th>
                <th>Service Date</th>
                <th className="text-center">Amount</th>
                <th>Card Number</th>
              </tr>
              </thead>
              <tbody>
	          {historyTable}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )}
  })



// WEBPACK FOOTER //
// ./src/components/billing/billing-history.jsx